"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoutFromMovistar = exports.logoutConvergente = exports.logoutTELCO = exports.mapContextParamsToCustoReq = exports.getSeoInfoFromContext = exports.mapContextParamsToPageEvent = exports.QUEUE_NAMES = exports.getUserPlatform = exports.isPriority = void 0;

var _common = require("../common");

var _metrics = require("../metrics");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* UTILS */

/**
 * Recupera si el usuario es priority o no
 * @returns {object} res with two props subseg and priorityCheck
 */
var isPriority = function isPriority() {
  var subseg = '';
  var priorityCheck = false;

  try {
    subseg = (0, _common.getCookie)('subseg');

    if (subseg === 'R7') {
      priorityCheck = true;
    }
  } catch (e) {// Mandar errores
  }

  return {
    subseg: subseg,
    priorityCheck: priorityCheck
  };
};
/**
 * Recupera la plataforma de usuario.
 * @returns [Telco|Legado|null]
 */


exports.isPriority = isPriority;

var getUserPlatform = function getUserPlatform() {
  var _isPriority = isPriority(),
      subseg = _isPriority.subseg;

  var subsegApply = window.location.host != 'www.movistar.es';
  var wacsessionid = (0, _common.getCookie)('wacsessionid');
  var smSession = (0, _common.getCookie)('SMSESSION');
  var leSession = (0, _common.getCookie)('LESESSION');
  var clientType = null;

  try {
    if (smSession && smSession !== 'LOGGEDOFF' && !leSession) {
      return 'Telco';
    }

    if (subseg && subsegApply || wacsessionid && wacsessionid !== '0' && wacsessionid !== 'null' || leSession && leSession !== '0' && leSession !== 'LOGEDOFF' && leSession !== 'null') {
      return 'Legado';
    }

    return clientType;
  } catch (e) {
    // Mandar error
    return clientType;
  }
};
/* NOOKINFO HELPERS */


exports.getUserPlatform = getUserPlatform;
var QUEUE_NAMES = {
  GLOBAL: 'Context',
  CUSTO: 'Context-Custo-Params',
  PAGE: 'Context-Page-Params',
  // ESta escucha los parametros que manda la pagina
  SEO_PARAMS: 'SEO_PARAMS',
  // Esta emite el seo ya solicitado
  SEO_DATA: 'SEO_DATA'
};
exports.QUEUE_NAMES = QUEUE_NAMES;

var mapContextParamsToPageEvent = function mapContextParamsToPageEvent(observerName, callBackNook) {
  var observer = observerName;

  if (!observer) {
    observer = "observer".concat(Date.now());
  }

  window.nookInfoExchange.registerAsObserver(QUEUE_NAMES.PAGE, observer, function (message) {
    var object = (0, _metrics.createPageEventObject)(message);

    if (typeof callBackNook === 'function') {
      callBackNook(object);
    }
  });
};

exports.mapContextParamsToPageEvent = mapContextParamsToPageEvent;

var getSeoInfoFromContext = function getSeoInfoFromContext(observerName, callBackNook) {
  var observer = observerName;

  if (!observer) {
    observer = "observer".concat(Date.now());
  } // TODOO


  window.nookInfoExchange.registerAsObserver(QUEUE_NAMES.SEO_DATA, observer, function (seoData) {
    if (typeof callBackNook === 'function') {
      callBackNook(seoData);
    }
  });
};

exports.getSeoInfoFromContext = getSeoInfoFromContext;

var mapContextParamsToCustoReq = function mapContextParamsToCustoReq(observerName, callBackNook) {
  var observer = observerName;

  if (!observer) {
    observer = "observer".concat(Date.now());
  }

  window.nookInfoExchange.registerAsObserver('Context-Custo-Params', observer, function (message) {
    var urlParams = (0, _common.getUrlParams)(true, [/levCode/g, /prodCode/g, /promoCode/g, /ctz_c/g, /webCode/g, /context.*/g, /custoHost/g, /businessClusters/g, /recomType/g]);
    var subseg = message.subseg,
        gwIspI3D = message.gwIspI3D,
        gwIsp = message.gwIsp,
        userType = message.userType,
        clientIDs = message.clientIDs,
        device = message.device,
        i3Ready = message.i3Ready,
        pageSegment = message.pageSegment,
        userPriority = message.userPriority,
        creativitiesHistory = message.creativitiesHistory,
        referalAP = message.referalAP,
        environment = message.environment;

    try {
      var custoObject = {
        i3Ready: i3Ready,
        ga: clientIDs.ga,
        pageId: clientIDs.pageId,
        paid: clientIDs.sessId,
        ctz_c: 'true',
        originUrl: window.location.href,
        context: {
          subseg: subseg,
          creativitiesHistory: creativitiesHistory,
          gw_isp: gwIsp,
          gw_isp_d: gwIspI3D,
          isLogado: userType !== null ? 'true' : 'false',
          tipoUsuario: userType,
          deviceType: device,
          seg_nav: pageSegment,
          isPriority: userPriority ? 'true' : 'false',
          referal_ap: referalAP,
          environment: environment
        }
      };

      if (urlParams.context) {
        urlParams.context = _objectSpread({}, custoObject.context, {}, urlParams.context);
      }

      custoObject = _objectSpread({}, custoObject, {}, urlParams);

      if (typeof callBackNook === 'function') {
        callBackNook(custoObject);
      }
    } catch (e) {
      console.log(e);
    }
  });
};
/**
 * Cierra sesión en Telco
 */


exports.mapContextParamsToCustoReq = mapContextParamsToCustoReq;

var logoutTELCO = function logoutTELCO(url) {
  document.location.assign(url);
  return null;
};
/**
 * Cierra sesión de usuario.
 */


exports.logoutTELCO = logoutTELCO;

var logoutConvergente = function logoutConvergente(url) {
  localStorage.removeItem('codigoOrden');
  localStorage.removeItem('numtlf');
  sessionStorage.removeItem('nameuser');
  sessionStorage.removeItem('urlhomeprivada');
  sessionStorage.removeItem('cclivr$$.api.misDatos');
  document.location.assign(url);
};

exports.logoutConvergente = logoutConvergente;

var logoutFromMovistar = function logoutFromMovistar() {
  var backToHome = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var urlToGo = backToHome ? 'https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=https%3A%2F%2Fwww.movistar.es%2F' : "https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=".concat(window.location.href);
  var clientType = getUserPlatform();

  if (clientType === 'Telco') {
    logoutTELCO(urlToGo);
  } else if (clientType === 'Legado') {
    logoutConvergente(urlToGo);
  }

  sessionStorage.removeItem('cmsNameUser');
  sessionStorage.removeItem('cmsIsPriority');
};

exports.logoutFromMovistar = logoutFromMovistar;

//# sourceMappingURL=index.js.map